import { LogOut } from 'lucide-react'
import { useAuth } from '@/lib/auth'
import { tenantConfig } from '@/lib/tenant'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'

export function Topbar() {
  const { user, logout } = useAuth()

  return (
    <header className="flex h-16 items-center justify-between border-b bg-card px-6">
      <div>
        <h1 className="text-sm font-medium text-muted-foreground">
          {tenantConfig.displayName} Dashboard
        </h1>
      </div>
      <div className="flex items-center gap-4">
        {user && (
          <>
            <span className="text-sm font-medium">{user.username}</span>
            <Badge variant={user.role === 'admin' ? 'default' : 'secondary'}>
              {user.role}
            </Badge>
          </>
        )}
        <Button variant="ghost" size="sm" onClick={logout}>
          <LogOut className="h-4 w-4" />
          Log out
        </Button>
      </div>
    </header>
  )
}
